import React, { createContext, useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { constants } from '../utils/constants'
import { useRouter } from 'next/router'
import { hasAuthCookie, hasRefreshCookie, redirectToLogin } from '../utils/helpers'
import { setAuthCookies } from '../utils/auth'
import { useFeatureProfile } from './FeatureProfileContext'

interface LoginParams {
  idToken: string
  email: string
  name?: string
  refreshToken: string
  authExpiry?: number
  refreshExpiry?: number
  intercomToken?: string
}

interface AuthContextType {
  login: (params: LoginParams) => void
  loggedIn: boolean
  logout: () => void
  showAnnouncement: boolean
}

const AuthContext = createContext({} as AuthContextType)

const AuthProvider = (props: any) => {
  const [showAnnouncement, setShowAnnouncement] = useState(false)
  const loggedIn = hasAuthCookie() || hasRefreshCookie()

  const {
    actions: { resetProfile }
  } = useFeatureProfile()

  const login = (params: LoginParams) => {
    const { idToken, refreshToken, authExpiry, refreshExpiry, intercomToken, email, name } = params
    setAuthCookies(idToken, refreshToken, authExpiry, refreshExpiry, intercomToken)
    Cookies.remove(constants.FLO_TNC_DIALOG_SHOWN)

    //Setting user data in localstorage
    Cookies.set(
      constants.FLO_USER_DATE,
      JSON.stringify({
        email: email,
        name: name
      }),
      {
        expires: constants.FLO_USER_COOKIE_EXPIRY,
        sameSite: 'none',
        secure: true
      }
    )
  }

  const logout = () => {
    resetProfile()
    redirectToLogin()
  }

  const authContextValue: AuthContextType = {
    login,
    loggedIn,
    logout,
    showAnnouncement
  }

  return <AuthContext.Provider value={authContextValue} {...props} />
}

const useAuth = () => React.useContext(AuthContext)

export { AuthProvider, useAuth }
